import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGreatBritainFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0003 58.2844V44.4683L9.68719 52.0693C12.6691 54.8173 16.1776 56.9317 20.0003 58.2844Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.9998 58.2848C43.8345 56.928 47.3528 54.8049 50.3407 52.0448L40.0018 44.4468L39.9998 58.2848Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.71455 39.9995C2.05811 40.9744 2.45248 41.9307 2.89603 42.8644L6.78508 39.9995H1.71455Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.2123 39.9995L57.1047 42.8664C57.5477 41.9317 57.9422 40.9748 58.2867 39.9995H53.2123Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4573 35.9995H0.602188C0.878992 37.3572 1.2507 38.6939 1.71457 39.9996H6.7851L2.89522 42.8645C3.68017 44.5122 4.61444 46.0845 5.68631 47.5618L16.0022 39.9996H20.0003V42.0695L8.29315 50.6925C8.74432 51.1656 9.20631 51.6265 9.68717 52.0696L20.0003 44.4685V58.2847C21.306 58.7484 22.6426 59.1203 24.0003 59.3976V35.9995H21.4573Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.3976 35.9995H36.0004V59.3982C37.3581 59.122 38.6946 58.7501 39.9998 58.2852L40.0018 44.4477L50.3407 52.0454C51.7231 50.7717 52.9827 49.3709 54.1029 47.8614L43.4477 39.9996H50.2186L56.2816 44.4685V44.4708C56.5716 43.9455 56.8459 43.4107 57.1046 42.8664L53.2122 39.9996H58.2861C58.7494 38.6938 59.1209 37.3572 59.3976 35.9995Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.71953 47.6064C6.49996 48.6809 7.35109 49.7022 8.26728 50.6636C8.27615 50.6733 8.28476 50.6836 8.29308 50.6924L20.0002 42.0694V39.9995H16.0459L5.71953 47.6064Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4621 39.9995L54.1132 47.8456C54.4836 47.3456 54.836 46.8314 55.1748 46.3084C55.2269 46.2285 55.2779 46.1486 55.3277 46.0686C55.6598 45.5456 55.98 45.0134 56.2808 44.4685L50.2186 39.9995H43.4621Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.9998 1.71289V15.5299L50.3129 7.92771C47.3301 5.18104 43.8219 3.06694 39.9998 1.71289Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0001 1.71289C16.1654 3.0696 12.647 5.19273 9.65927 7.95296L19.9982 15.5518L20.0001 1.71289Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.2861 19.9996C57.9418 19.0245 57.5473 18.0679 57.1041 17.1335L53.2137 19.9996H58.2861Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.78841 19.9997L2.8952 17.1328C2.45217 18.0673 2.05809 19.0242 1.71455 19.9997H6.78841Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.542 23.9995H59.3976C59.1207 22.6419 58.7493 21.3053 58.2861 19.9995H53.2136L57.1046 17.1335C56.3192 15.4862 55.385 13.914 54.3138 12.4364L43.9971 19.9995H39.9998V17.9298L51.7056 9.30655C51.2558 8.83374 50.7932 8.37173 50.3121 7.92974L39.9998 15.5305V1.7127C38.6942 1.24938 37.3578 0.87777 36.0004 0.600586V23.9995H38.542Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.602188 23.9995H24.0003V0.600586C22.6425 0.87709 21.3059 1.24871 20.0003 1.7127L19.9983 15.5516L9.65943 7.9536C8.27734 9.22779 7.01766 10.6287 5.89692 12.1379L16.5516 19.9987H16.5374L9.78124 19.9995L3.71848 15.5297V15.5286C3.42852 16.0536 3.1541 16.5883 2.89522 17.1327L6.78843 19.9995H1.71457C1.25024 21.305 0.878523 22.6417 0.602188 23.9995Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.2811 12.3917C53.5006 11.3169 52.649 10.2957 51.7319 9.33481C51.7225 9.32509 51.715 9.31483 51.7069 9.30566L39.9998 17.929V19.9997H43.9533L54.2811 12.3917Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5378 19.9989L5.88732 12.1528C5.51606 12.6528 5.16395 13.1678 4.82515 13.6911C4.77299 13.7699 4.72276 13.8499 4.67199 13.9298C4.34013 14.4528 4.02048 14.985 3.71887 15.5299L9.78108 19.9997L16.5378 19.9989Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.3976 23.9997H36.0003V0.600726C32.0404 -0.200616 27.96 -0.200238 24.0002 0.601839V23.9997H0.602114C-0.200705 27.9593 -0.200705 32.0398 0.602114 35.9995H24.0002V59.3981C27.9601 60.2 32.0405 60.1998 36.0003 59.3976V35.9995H59.3976C60.2008 32.0399 60.2008 27.9593 59.3976 23.9997Z",
			fill: "#ED4C5C"
		})
	]
});
export default SvgGreatBritainFlag;
